import * as Factory from 'factory.ts'
import faker from 'faker'

import { type PDFLabelSet } from '@webapp/models'

const PDFLabelSetOrderItemMock = Factory.Sync.makeFactory<
  PDFLabelSet['value']['orderitem']
>({
  'Item Description': faker.lorem.word(),
  'Total Price': faker.lorem.word(),
  po_note: faker.lorem.word(),
  price: faker.lorem.word(),
  quantity: faker.lorem.word(),
  sku: faker.lorem.word(),
  unit: faker.lorem.word(),
})

const PDFLabelSetPOMock = Factory.Sync.makeFactory<PDFLabelSet['value']['po']>({
  PO_Number: faker.lorem.word(),
  'Purchase Order': faker.lorem.word(),
  'Ship To': faker.lorem.word(),
  comment: faker.lorem.word(),
  creditcard: faker.lorem.word(),
  date: faker.lorem.word(),
  discount: faker.lorem.word(),
  freight: faker.lorem.word(),
  other: faker.lorem.word(),
  payment_terms: faker.lorem.word(),
  pref_vendor: faker.lorem.word(),
  promise_date: faker.lorem.word(),
  shipping_method: faker.lorem.word(),
  shipping_terms: faker.lorem.word(),
  subtotal: faker.lorem.word(),
  tax: faker.lorem.word(),
  total: faker.lorem.word(),
})

export const PDFLabelSetValueMock = Factory.Sync.makeFactoryWithRequired<
  PDFLabelSet['value'],
  'name'
>({
  orderitem: PDFLabelSetOrderItemMock.build(),
  po: PDFLabelSetPOMock.build(),
})

export const PDFLabelSetMock = Factory.Sync.makeFactoryWithRequired<
  PDFLabelSet,
  'key' | 'value'
>({
  is_primary: false,
})
